import { defineMessages } from "react-intl";

export default defineMessages({
  yourPaymentPreferencesHaveBeenSaved: {
    id: "contracts.yourPaymentPreferencesHaveBeenSaved",
    defaultMessage: "Your payment preferences have been saved.",
  },
  congratsYourSubscriptionHasBeenActivated: {
    id: "contracts.congratsYourSubscriptionHasBeenActivated",
    defaultMessage:
      "Congratulations! Your <inline><bold>Ring Twice</bold> <plus></plus></inline> subscription has been activated.",
  },
});
